<template>
  <div
    class="tir-pm-comment-chat-quote-message"
    :class="{
      'tir-pm-comment-chat-quote-message--clickable': props.isClickable,
    }"
    @click="toReplyMessage"
  >
    <div class="tir-pm-comment-chat-quote-message__message">
      <div class="tir-pm-comment-chat-quote-message__inner-user-foto">
        <!-- computedCommentData -->
        <TirPmTooltipElement>
          <TirPmIconView
            :size="24"
            isRounded
            :colorCode="computedCommentData.Author.AvatarColor"
            :imageLoadUrl="computedCommentData.Author.ImageUrl"
          >
            <template #mainSlot>
              {{ computedCommentData.Author?.FirstName[0].toUpperCase()
              }}{{ computedCommentData.Author?.LastName[0].toUpperCase() }}
            </template>
          </TirPmIconView>
          <template #content>
            <div class="tir-pm-comment-chat-quote-message__author-info">
              {{ computedCommentData.Author.FirstName }} {{ computedCommentData.Author.MiddleName }}
              {{ computedCommentData.Author.LastName }}
            </div>
          </template>
        </TirPmTooltipElement>
      </div>
      <div class="tir-pm-comment-chat-quote-message__message-text">
        {{ computedCommentData.Message }}
      </div>
    </div>
    <div class="tir-pm-comment-chat-quote-message__right-area">
      <TirPmFilePreview
        v-if="previewFile"
        :file="previewFile"
        :variant="FilePreviewVariantEnum.Inline"
        is-disabled-open
        hide-controls
      />
      <div
        class="tir-pm-comment-chat-quote-message__close-button"
        v-if="isDelitable"
        @click="onDeleteReply"
        title="Удалить ответ"
      >
        <CrossCompactIcon></CrossCompactIcon>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  IFilePreview,
  TirPmIconView,
  TirPmFilePreview,
  FilePreviewVariantEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { CrossCompactIcon } from 'tir-style-system/icons/outline';
import { computed } from 'vue';
import { CommentChatMessageModel } from './models';

/**
 * События
 */
const emit = defineEmits<{
  /**
   * Отправка события удаления комментария на который отвечают
   */
  (eventName: 'deleteReply', value: CommentChatMessageModel): void;
  /**
   * Отправка события для перемещения к комментарию
   */
  (eventName: 'toReply', value: CommentChatMessageModel): void;
}>();

/**Параметры компонента */
const props = defineProps<{
  commentData: CommentChatMessageModel;
  isDelitable?: boolean;
  isClickable?: boolean;
}>();

/**
 * Отправка события удаления комментария на который отвечают
 */
const onDeleteReply = () => {
  emit('deleteReply', computedCommentData.value);
};

/**
 * Отправка события для перемещения к комментарию
 */
const toReplyMessage = () => {
  if (props.isClickable) {
    emit('toReply', computedCommentData.value);
  }
};

/**
 * Данные
 */
const computedCommentData = computed(() => props.commentData);

const previewFile = computed<IFilePreview | undefined>(() => {
  if (props.commentData.File) {
    return {
      FileId: props.commentData.File.Id,
      Name: props.commentData.File.Name,
      Url: props.commentData.File.Url,
    };
  }
});
</script>

<style lang="scss">
@import './style/tir-pm-comment-chat-quote-message';
</style>
